import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PrivacyProvider } from "@/context/PrivacyContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import StaffLogin from "@/pages/StaffLogin";
import Dashboard from "@/pages/Dashboard";
import Clientes from "@/pages/Clientes";
import ClienteDetalhe from "@/pages/ClienteDetalhe";
import NovaVenda from "@/pages/NovaVenda";
import ScanCarne from "@/pages/ScanCarne";
import Importar from "@/pages/Importar";
import Dados from "@/pages/Dados";
import Equipe from "@/pages/Equipe";
import Rotas from "@/pages/Rotas";
import ConferenciaRota from "@/pages/ConferenciaRota";
import MinhaRota from "@/pages/MinhaRota";
import Relatorios from "@/pages/Relatorios";
import { Shield, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

function Forbidden() {
  const nav = useNavigate();
  return (
    <div className="text-center py-20">
      <div className="w-16 h-16 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4">
        <Shield className="w-8 h-8" />
      </div>
      <h2 className="font-display text-2xl font-extrabold text-stone-900 mb-1">Área restrita</h2>
      <p className="text-sm text-stone-500 mb-5">Essa área é só do administrador.</p>
      <button onClick={() => nav("/")} className="btn-primary inline-flex"><ArrowLeft className="w-4 h-4" /> Voltar ao painel</button>
    </div>
  );
}

function Protected({ children, require }) {
  const { session, loading, business, isAdmin } = useAuth();
  if (loading) return <div className="p-10 text-center text-stone-500">Carregando…</div>;
  if (!session) {
    if (business) return <Navigate to="/staff-login" replace />;
    return <Navigate to="/login" replace />;
  }
  if (require === "admin" && !isAdmin) return <Layout><Forbidden /></Layout>;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PrivacyProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/staff-login" element={<StaffLogin />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/clientes" element={<Protected><Clientes /></Protected>} />
              <Route path="/clientes/:id" element={<Protected><ClienteDetalhe /></Protected>} />
              <Route path="/nova-venda" element={<Protected><NovaVenda /></Protected>} />
              <Route path="/scan" element={<Protected><ScanCarne /></Protected>} />
              <Route path="/importar" element={<Protected require="admin"><Importar /></Protected>} />
              <Route path="/dados" element={<Protected require="admin"><Dados /></Protected>} />
              <Route path="/equipe" element={<Protected require="admin"><Equipe /></Protected>} />
              <Route path="/rotas" element={<Protected require="admin"><Rotas /></Protected>} />
              <Route path="/rotas/:rid/conferencia" element={<Protected require="admin"><ConferenciaRota /></Protected>} />
              <Route path="/minha-rota" element={<Protected><MinhaRota /></Protected>} />
              <Route path="/relatorios" element={<Protected require="admin"><Relatorios /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </PrivacyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
